import $ from 'jquery'
import template from 'templates/modal-ajax.pug'

import modal from 'scripts/components/modal'
import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import alert from 'scripts/utils/alert'

class ModalAjax extends BaseComponent {
  static componentName = 'modal-ajax'

  static DOMEvents = {
    click: 'onElementClick'
  }

  init () {
    this.endpoint = this.$element.attr('href')
    this.modalTitle = this.$element.data('modal-title')
  }

  setModal (templateData) {
    this.modal = this.modal || $(template(templateData)).modal().data('modal')
  }

  showModal () {
    hideSpinner()

    this.modal.show()
  }

  onElementClick (event) {
    event.preventDefault()

    if (this.modal) {
      return this.showModal()
    }

    this.fetchContent()
  }

  fetchContent () {
    showSpinner()

    $.ajax({
      dataType: 'json',
      url: this.endpoint,
      xhrFields: {
        withCredentials: true
      }
    })
      .done(this.onFetchContentSuccess.bind(this))
      .fail(this.onFetchContentFailure.bind(this))
  }

  onFetchContentSuccess (data) {
    const templateData = {
      title: this.modalTitle,
      content: data.text
    }

    this.setModal(templateData)
    this.showModal()
  }

  onFetchContentFailure () {
    hideSpinner()

    alert('Não foi possivel carregar este conteúdo. Tente novamente mais tarde.')
  }
}

export default ($el) => new ModalAjax($el).init()

export { ModalAjax as Component }
